import ClearIcon from "@mui/icons-material/Clear";
import { FormControl } from "@mui/material";
import { AnimatePresence } from "framer-motion";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import ReactSelect from "react-select";
import CloseIcon from "../../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../../../components/HeaderCadastro/HeaderCadastro";
import ModalConfirmacao from "../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";
import TabelaV2 from "../../../../components/TabelaV2/TabelaV2";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../../contexts/RequestController";
import TabelaRedux from "../../../../contexts/Tabela";
import MotionContainer from "../../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../../core/components/Separator.tsx";
import Layout from "../../../../core/layout/Layout.tsx";
import { documentoValido } from "../../../../core/utils/validators.ts";
import { cnpjMask } from "../../../../regex/cnpjMask";
import {
    cadastraEmpresaSub,
    deleteEmpresaSubPorId,
    editaEmpresaSubPorId,
    getEmpresaSub,
    getEmpresaSubPorId,
} from "../../../../services/ModuloGerenciador/EmpresaSub";
import { getEmpresaSubDependencias } from "../../../../services/ModuloGerenciador/Geral.ts";
import "./EmpresaSubsidiaria.css";

const opcoes = [
    {
        opcao: "Simples nacional",
    },
    {
        opcao: "Lucro presumido",
    },
    {
        opcao: "Lucro real",
    },
];

const opcoesRegime = opcoes.map((data) => ({
    value: data.opcao,
    label: data.opcao,
    ...data,
}));

const labelRegime = (data) => <div>{data.opcao}</div>;

function EmpresaSubsidiaria(props) {
    const { profile, hasRegra, tabelaEmpresa } = useProfile();

    const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

    const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

    const [dadosTabela, setDadosTabela] = useState([]);

    const [telaCadastro, setTelaCadastro] = useState(false);

    const [editando, setEditando] = useState(false);

    const [loading, setLoading] = useState(false);

    const [values, setValues] = useState({
        nome: "",
        nomeSocial: "",
        rua: "",
        numero: "",
        bairro: "",
        cep: "",
        cnpj: "",
        cidadeEstadoId: 0,
        regimeTributario: 0,
    });

    const [validator, setValidator] = useState({
        nome: "true",
        nomeSocial: "true",
        rua: "true",
        numero: "true",
        bairro: "true",
        cep: "true",
        cnpj: "true",
        cidadeEstadoId: "true",
        regimeTributario: "false",
    });

    const [listaCidades, setListaCidades] = useState([]);

    const [openUsuario, setOpenUsuario] = useState(false);

    const [open, setOpen] = useState(false);

    const [textoSucesso, setTextoSucesso] = useState("");

    const [textoErro, setTextoErro] = useState("");

    const handleClose = () => {
        setOpen(false);
    };

    const [openToastSucesso, setOpenToastSucesso] = useState(false);

    const handleCloseToastSucesso = () => {
        setOpenToastSucesso(false);
    };

    const [openToastErro, setOpenToastErro] = useState(false);

    const handleCloseToastErro = () => {
        setOpenToastErro(false);
    };

    const handleCloseUsuario = () => {
        setOpenUsuario(false);
    };

    const buscarDependencias = async () => {
        setLoading(true);
        await getEmpresaSubDependencias(profile?.token)
            .then((result) => {
                setListaCidades(result.data.cidadeEstados);
                setDadosTabela(result.data.empresaSubs);
                setTabelaRedux({});
            })
            .catch((error) => {
                if (typeof error.response.data === "string") {
                    setTextoErro(error.response.data);
                    setOpenToastErro(true);
                } else {
                    setTextoErro(
                        "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
                    );
                    setOpenToastErro(true);
                }
            });
        setLoading(false);
    };

    const buscarEmpresa = async () => {
        setLoading(true);
        await getEmpresaSub(profile?.token)
            .then((result) => {
                setDadosTabela(result.data);
                setTabelaRedux({});
                setLoading(false);
            })
            .catch((error) => {
                if (typeof error.response.data === "string") {
                    setTextoErro(error.response.data);
                    setOpenToastErro(true);
                    setLoading(false);
                } else {
                    setTextoErro(
                        "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
                    );
                    setOpenToastErro(true);
                    setLoading(false);
                }
                setLoading(false);
            });
    };

    const preencherDadosEditando = async (result) => {
        let regimeTributario;
        if (result.data.regimeTributario === 1) {
            regimeTributario = "Simples nacional";
        } else if (result.data.regimeTributario === 2) {
            regimeTributario = "Lucro presumido";
        } else if (result.data.regimeTributario === 3) {
            regimeTributario = "Lucro real";
        }
        const regimeTributarioSelecionado = opcoesRegime.find(
            (option) => option.value === regimeTributario
        );
        if (regimeTributarioSelecionado) {
            setValuesSelect((current) => ({
                ...current,
                regimeTributario: regimeTributarioSelecionado,
            }));
            setValues((current) => ({
                ...current,
                regimeTributario: result.data.regimeTributario,
            }));
        }
        const cidadeSelecionado = listaCidades.find(
            (option) => option.idCidadeEstado === result.data.cidadeEstadoId
        );
        if (cidadeSelecionado) {
            setValuesSelect((current) => ({
                ...current,
                cidadeEstadoId: cidadeSelecionado,
            }));
            setValues((current) => ({
                ...current,
                cidadeEstadoId: result.data.cidadeEstadoId,
            }));
            setValidator((current) => ({
                ...current,
                cidadeEstadoId: "true",
            }));
        }
        if (!!result.data.idEmpresaSub) {
            setValues((current) => ({
                ...current,
                idEmpresaSub: result.data.idEmpresaSub,
            }));
        }
        if (!!result.data.nome) {
            setValues((current) => ({
                ...current,
                nome: result.data.nome,
            }));
            setValidator((current) => ({
                ...current,
                nome: "true",
            }))
        }
        if (!!result.data.nomeSocial) {
            setValues((current) => ({
                ...current,
                nomeSocial: result.data.nomeSocial,
            }));
            setValidator((current) => ({
                ...current,
                nomeSocial: "true",
            }))
        }
        if (!!result.data.cnpj) {
            setValues((current) => ({
                ...current,
                cnpj: result.data.cnpj,
            }));
            setValidator((current) => ({
                ...current,
                cnpj: "true",
            }))
        }
        if (!!result.data.endereco.cep) {
            setValues((current) => ({
                ...current,
                cep: result.data.endereco.cep,
            }));
            setValidator((current) => ({
                ...current,
                cep: "true",
            }))
        }
        if (!!result.data.endereco.rua) {
            setValues((current) => ({
                ...current,
                rua: result.data.endereco.rua,
            }));
            setValidator((current) => ({
                ...current,
                rua: "true",
            }))
        }
        if (!!result.data.endereco.bairro) {
            setValues((current) => ({
                ...current,
                bairro: result.data.endereco.bairro,
            }));
            setValidator((current) => ({
                ...current,
                bairro: "true",
            }))
        }
        if (!!result.data.endereco.numero) {
            setValues((current) => ({
                ...current,
                numero: result.data.endereco.numero,
            }));
            setValidator((current) => ({
                ...current,
                numero: "true",
            }))
        }
    };

    const buscarEmpresaPorID = async () => {
        await getEmpresaSubPorId(tabelaRedux.colunaSelecionada, profile?.token)
            .then(async (result) => {
                if (result.status === 200) {
                    if (editando) {
                        await preencherDadosEditando(result);
                    }
                }
            })
            .catch((error) => {
                if (!editando) {
                    if (typeof error.response.data === "string") {
                        setTextoErro(error.response.data);
                    } else {
                        setTextoErro(
                            "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
                        );
                    }
                    setOpenToastErro(true);
                }
            });
    };

    const buscarEmpresaPorIDModal = async (id) => {
        await getEmpresaSubPorId(id, profile?.token)
            .then(async (result) => {
                if (result.status === 200) {
                    await preencherDadosEditando(result);
                    setValues(result.data);
                }
            })
            .catch((error) => {
                if (!editando) {
                    if (typeof error.response?.data === "string") {
                        setTextoErro(error.response.data);
                    } else {
                        setTextoErro(
                            "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
                        );
                    }
                    setOpenToastErro(true);
                }
            });
    };

    const cadastrar = async () => {
        if (!documentoValido(values.cnpj)) {
            setTextoErro("CNPJ inválido");
            setOpenToastErro(true);
            setValidator((current) => ({ ...current, cnpj: "false" }));
            return;
        }
        if (!values.cidadeEstadoId) {
            setValidator((current) => ({
                ...current,
                cidadeEstadoId: "false",
            }));
            setTextoErro("Cidade/Estado inválido!");
            setOpenToastErro(true);
            return;
        }
        if (!values.numero || values.numero === 0) {
            setValidator((current) => ({
                ...current,
                numero: "false",
            }));
            setTextoErro("Número inválido!");
            setOpenToastErro(true);
            return;
        }
        if (!values.cep) {
            setValidator((current) => ({
                ...current,
                cep: "false",
            }));
            setTextoErro("Cep inválido!");
            setOpenToastErro(true);
            return;
        }
        if (!values.rua) {
            setValidator((current) => ({
                ...current,
                rua: "false",
            }));
            setTextoErro("Rua inválida!");
            setOpenToastErro(true);
            return;
        }
        if (!values.bairro) {
            setValidator((current) => ({
                ...current,
                bairro: "false",
            }));
            setTextoErro("Bairro inválido!");
            setOpenToastErro(true);
            return;
        }
        if (!values.cnpj) {
            setValidator((current) => ({
                ...current,
                cnpj: "false",
            }));
            setTextoErro("CNPJ/CPF inválido!");
            setOpenToastErro(true);
            return;
        }
        if (!values.nome) {
            setValidator((current) => ({
                ...current,
                nome: "false",
            }));
            setTextoErro("Nome inválido!");
            setOpenToastErro(true);
            return;
        }
        if (!values.nomeSocial) {
            setValidator((current) => ({
                ...current,
                nomeSocial: "false",
            }));
            setTextoErro("Nome Social inválido!");
            setOpenToastErro(true);
            return;
        }
        setLoading(true);
        if (
            !!values.nome &&
            !!values.nomeSocial &&
            !!values.cidadeEstadoId &&
            !!values.cep &&
            !!values.rua &&
            !!values.bairro &&
            !!values.numero &&
            validator.nome === "true" &&
            validator.nomeSocial === "true" &&
            validator.cidadeEstadoId === "true" &&
            validator.cnpj === "true" &&
            validator.rua === "true" &&
            validator.cep === "true" &&
            validator.bairro === "true" &&
            validator.numero === "true"
        ) {
            const payload = {
                idEmpresaSub: values.idEmpresaSub,
                cidadeEstadoId: values.cidadeEstadoId,
                nome: values.nome,
                nomeSocial: values.nomeSocial,
                cnpj: values.cnpj,
                regimeTributario: values.regimeTributario,
                endereco: {
                    rua: values.rua,
                    numero: values.numero,
                    bairro: values.bairro,
                    cep: values.cep,
                    cidade: listaCidades.find((item) => item.idCidadeEstado === values.cidadeEstadoId)
                        .cidade,
                }
            }
            await cadastraEmpresaSub(payload, profile?.token)
                .then((result) => {
                    if (result.status === 200) {
                        buscarEmpresa();
                        setDadosRequestControllerRedux("Fechar Modal Empresa");
                        setTabelaRedux({});
                        setTextoSucesso("Cadastrado Com Sucesso");
                        setOpenToastSucesso(true);
                        setValues({});
                        setValuesSelect({});
                        setTelaCadastro(false);
                    }
                })
                .catch((error) => {
                    if (typeof error.response.data === "string") {
                        setTextoErro(error.response.data);
                    } else {
                        setTextoErro(
                            "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
                        );
                    }
                    setOpenToastErro(true);
                });
        } else {
            setTextoErro("Há campos sem preencher!");
            setOpenToastErro(true);
        }
        setLoading(false);
    };

    const editar = async () => {
        if (!documentoValido(values.cnpj)) {
            setTextoErro("CNPJ inválido");
            setOpenToastErro(true);
            setValidator((current) => ({ ...current, cnpj: "false" }));
            return;
        }
        if (!values.cidadeEstadoId) {
            setValidator((current) => ({
                ...current,
                cidadeEstadoId: "false",
            }));
            setTextoErro("Cidade/Estado inválido!");
            setOpenToastErro(true);
            return;
        }
        if (!values.numero || values.numero === 0) {
            setValidator((current) => ({
                ...current,
                numero: "false",
            }));
            setTextoErro("Número inválido!");
            setOpenToastErro(true);
            return;
        }
        if (!values.cep) {
            setValidator((current) => ({
                ...current,
                cep: "false",
            }));
            setTextoErro("Cep inválido!");
            setOpenToastErro(true);
            return;
        }
        if (!values.rua) {
            setValidator((current) => ({
                ...current,
                rua: "false",
            }));
            setTextoErro("Rua inválida!");
            setOpenToastErro(true);
            return;
        }
        if (!values.bairro) {
            setValidator((current) => ({
                ...current,
                bairro: "false",
            }));
            setTextoErro("Bairro inválido!");
            setOpenToastErro(true);
            return;
        }
        if (!values.cnpj) {
            setValidator((current) => ({
                ...current,
                cnpj: "false",
            }));
            setTextoErro("CNPJ/CPF inválido!");
            setOpenToastErro(true);
            return;
        }
        if (!values.nome) {
            setValidator((current) => ({
                ...current,
                nome: "false",
            }));
            setTextoErro("Nome inválido!");
            setOpenToastErro(true);
            return;
        }
        if (!values.nomeSocial) {
            setValidator((current) => ({
                ...current,
                nomeSocial: "false",
            }));
            setTextoErro("Nome Social inválido!");
            setOpenToastErro(true);
            return;
        }
        setLoading(true);

        if (
            !!values.nome &&
            !!values.nomeSocial &&
            !!values.cidadeEstadoId &&
            !!values.cep &&
            !!values.rua &&
            !!values.bairro &&
            !!values.numero &&
            validator.nome === "true" &&
            validator.nomeSocial === "true" &&
            validator.cidadeEstadoId === "true" &&
            validator.cnpj === "true" &&
            validator.rua === "true" &&
            validator.cep === "true" &&
            validator.bairro === "true" &&
            validator.numero === "true"
        ) {
            const payload = {
                idEmpresaSub: values.idEmpresaSub,
                cidadeEstadoId: values.cidadeEstadoId,
                nome: values.nome,
                nomeSocial: values.nomeSocial,
                cnpj: values.cnpj,
                regimeTributario: values.regimeTributario,
                endereco: {
                    rua: values.rua,
                    numero: values.numero,
                    bairro: values.bairro,
                    cep: values.cep,
                    cidade: listaCidades.find((item) => item.idCidadeEstado === values.cidadeEstadoId)
                        .cidade,
                }
            }
            await editaEmpresaSubPorId(payload, profile?.token)
                .then((result) => {
                    if (result.status === 200) {
                        buscarEmpresa();
                        setTabelaRedux({});
                        setTextoSucesso("Editado Com Sucesso");
                        setOpenToastSucesso(true);
                        setTelaCadastro(false);
                        setEditando(false);
                    }
                })
                .catch((error) => {
                    if (typeof error.response.data === "string") {
                        setTextoErro(error.response.data);
                        setOpenToastErro(true);
                        setLoading(false);
                    } else {
                        setTextoErro(
                            "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
                        );
                        setOpenToastErro(true);
                        setLoading(false);
                    }
                    setLoading(false);
                });
        } else {
            setTextoErro("Há campos sem preencher!");
            setOpenToastErro(true);
        }
        setLoading(false);
    };

    const deletarEmpresa = async () => {
        setLoading(true);
        await deleteEmpresaSubPorId(tabelaRedux.colunaSelecionada, profile?.token)
            .then((result) => {
                if (result.status === 200) {
                    buscarEmpresa();
                    setTabelaRedux({});
                    setOpenToastSucesso(true);
                }
            })
            .catch((error) => {
                if (typeof error.response.data === "string") {
                    setTextoErro(error.response.data);
                    setOpenToastErro(true);
                    setLoading(false);
                } else {
                    setTextoErro(
                        "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
                    );
                    setOpenToastErro(true);
                    setLoading(false);
                }
                setLoading(false);
            });
    };

    const title = useMemo(() => {
        if (editando) return "Detalhes de Empresa";
        if (telaCadastro) return "Cadastro de Empresa";
        return "Empresa Subsidiária";
    }, [editando, telaCadastro]);

    useEffect(() => {
        if (editando) {
            buscarEmpresaPorID();
        }
    }, [editando]);

    useEffect(() => {
        if (props.idAtual) {
            buscarEmpresaPorIDModal(props.idAtual);
        }
    }, [props.idAtual]);

    useEffect(() => {
        if (!!props.telaCadastro || telaCadastro) {
            setTelaCadastro(true);
            setValidator((current) => ({
                ...current,
                nome: "true",
                nomeSocial: "true",
                rua: "true",
                numero: "true",
                bairro: "true",
                cep: "true",
                cnpj: "true",
                cidadeEstadoId: "true",
            }));
            setValues({});
        }
    }, [props.telaCadastro, telaCadastro]);

    const [semAutorizacao, setSemAutorizacao] = useState(false);

    useEffect(() => {
        if (profile?.token) {
            setSemAutorizacao(!hasRegra("Uso Comum"));
            buscarDependencias();
        }
    }, [profile?.token]);

    const [valuesSelect, setValuesSelect] = useState([]);

    const labelCidadeEstado = (data) => (
        <div style={{ display: "flex", alignItems: "center" }}>
            {data.cidade} - {data.estado}
            {valuesSelect.cidadeEstadoId === data && (
                <ClearIcon
                    className="info-icon"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        clearCidade();
                    }}
                />
            )}
        </div>
    );

    const clearCidade = () => {
        setValues((current) => ({
            ...current,
            cidadeEstadoId: null,
        }));
        setValuesSelect((current) => ({ ...current, cidadeEstadoId: "" }));
        setValidator((current) => ({
            ...current,
            cidadeEstadoId: "false",
        }));
    };

    const estiloCidadeEstado = (invalid) => ({
        control: (provided) => ({
            ...provided,
            minHeight: "30px",
            borderRadius: "7px",
            border: invalid ? "1px solid #f44336" : "1px solid var(--Background-Input, #F2F2F2)",
            background: "var(--Background-Input, #F2F2F2)",
            "&:hover": {
                background: "#F0F6FF",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "var(--Placeholder-Color, #888)",
            fontSize: "12px",
        }),
        menu:
            (provided) => ({
                ...provided,
                width: "max-content",
                minWidth: props.classeCss ? props.classeCss : "270px",
            }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 1400,
        }),
        singleValue:
            (provided) => ({
                ...provided,
                fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
            }),
        option:
            (provided) => ({
                ...provided,
                fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
            }),
    });

    const handleChangeDocumento = useCallback(
        (e) => {
            setValues((current) => ({
                ...current,
                cnpj: cnpjMask(e.target.value),
            }));
            setValidator((current) => ({
                ...current,
                cnpj: "true",
            }));
        },
        []
    );

    const opcoesCidadeEstado = listaCidades.map((data) => ({
        value: data.idCidadeEstado,
        label: `${data.cidade} - ${data.estado}`,
        ...data,
    }));

    if (semAutorizacao) {
        return <MotionSemAutorizacao />;
    }

    return (
        <Layout title={title} showNavbar={props.navbar}>
            <AnimatePresence mode="wait">
                {!telaCadastro ? (
                    <MotionContainer key="EmpresaSubsidiariaContainer">
                        <div className="content-container">
                            <Separator size="xl" />
                            <TabelaV2
                                setTelaCadastro={setTelaCadastro}
                                setEditando={setEditando}
                                classeSelecionado="idEmpresaSub"
                                nomeClasse1="outer-wrapper-v2"
                                nomeClasse2="table-v2-center"
                                colunas={tabelaEmpresa.EmpresaSub}
                                dados={dadosTabela}
                                isLoading={loading}
                            />
                        </div>
                        <div className="footer-container">
                            <div>
                                <CustomButtonV2
                                    classCss="custom-button-cadastrar"
                                    classText="button-texto-cadastrar"
                                    icone="iconeSave"
                                    titulo="Cadastrar"
                                    cor="#0946B8"
                                    valor={values}
                                    onClick={() => {
                                        setTelaCadastro(true);
                                        setEditando(false);
                                    }}
                                />
                                <CustomButtonV2
                                    classCss="custom-button-editar"
                                    classText="button-texto-editar"
                                    titulo="Editar"
                                    icone="iconeEdit"
                                    cor="#CDCDCD"
                                    valor={values}
                                    onClick={() => {
                                        if (tabelaRedux.colunaSelecionada) {
                                            setTelaCadastro(true);
                                            setEditando(true);
                                        } else {
                                            setTextoErro("Selecione Uma Coluna");
                                            setOpenToastErro(true);
                                        }
                                    }}
                                />
                                <CustomButtonV2
                                    classCss="custom-button-deletar"
                                    classText="button-texto-cadastrar"
                                    titulo="Deletar"
                                    icone="iconeDelete"
                                    cor="#DC2D2D"
                                    valor={values}
                                    onClick={() => {
                                        if (tabelaRedux.colunaSelecionada) {
                                            setOpen(true);
                                            setTextoSucesso("Deletado Com Sucesso");
                                        } else {
                                            setTextoErro("Selecione Uma Coluna");
                                            setOpenToastErro(true);
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <CustomButtonV2
                                    classCss="custom-button-user"
                                    classText="button-texto-user"
                                    titulo="Obter Usuário"
                                    cor="#FFFFFF"
                                    valor={values}
                                    onClick={() => {
                                        if (tabelaRedux.usuarioAlteracao) {
                                            setOpenUsuario(true);
                                        } else {
                                            setTextoErro("Selecione Uma Coluna");
                                            setOpenToastErro(true);
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </MotionContainer>
                ) : (
                    <MotionContainer key="EmpresaSubsidiariaCadastroContainer">
                        <div className="content-container">
                            {!props.desabilitar && (
                                <div className="texto-cadastro-container">
                                    {props.botaoFechar !== false && (
                                        <div style={{ width: 29, height: 29 }} />
                                    )}
                                    <div className="texto-cadastro">
                                        <p className="indicador-emb">{"Cadastro de Empresa / "}</p>
                                        {editando ? (
                                            <p className="indicador-emb">{"Detalhes de Empresa"}</p>
                                        ) : (
                                            <p className="indicador-emb">{"Cadastro de Empresa"}</p>
                                        )}
                                        <HeaderCadastro texto="" />
                                    </div>
                                    {props.botaoFechar !== false && (
                                        <div className="close-btn">
                                            <CloseIcon
                                                onClick={() => {
                                                    setValues({});
                                                    setTelaCadastro(false);
                                                    setEditando(false);
                                                    setTabelaRedux({});
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className="container-form-row">
                                <div className="container-form-column">
                                    <div className="coluna-emb">
                                        <div className="principal">
                                            <p className="input-label-emb">
                                                Nome:
                                            </p>
                                            <input
                                                type="text"
                                                id="nome"
                                                className="input-emb"
                                                style={{
                                                    width: "270px",
                                                    borderColor:
                                                        validator.nome === "false" ? "red" : "",
                                                }}
                                                onChange={(e) => {
                                                    setValues((current) => ({
                                                        ...current,
                                                        nome: e.target.value,
                                                    }));
                                                    setValidator((current) => ({
                                                        ...current,
                                                        nome: "true",
                                                    }));
                                                }}
                                                placeholder="Ex: TS"
                                                value={values.nome}
                                                disabled={props.desabilitar}
                                            />
                                            {validator.nome === "false" && (
                                                <p className="error-input-text">Nome inválido</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="coluna-emb">
                                        <div className="principal">
                                            <p className="input-label-emb" htmlFor="nomeSocial">
                                                Nome Social:
                                            </p>
                                            <input
                                                type="text"
                                                id="nomeSocial"
                                                className="input-emb"
                                                style={{
                                                    width: "270px",
                                                    borderColor:
                                                        validator.nomeSocial === "false" ? "red" : "",
                                                }}
                                                onChange={(e) => {
                                                    setValues((current) => ({
                                                        ...current,
                                                        nomeSocial: e.target.value,
                                                    }));
                                                    setValidator((current) => ({
                                                        ...current,
                                                        nomeSocial: "true",
                                                    }));
                                                }}
                                                placeholder="Ex: Trans-Scalcon Transportes Rodoviarios Ltda"
                                                value={values.nomeSocial}
                                                disabled={props.desabilitar}
                                            />
                                            {validator.nomeSocial === "false" && (
                                                <p className="error-input-text">Nome Social inválido</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="coluna-emb">
                                        <div className="principal">
                                            <p className="input-label-emb">
                                                CPF/CNPJ:
                                            </p>
                                            <input
                                                type="text"
                                                className="input-emb"
                                                style={{
                                                    width: "270px",
                                                    borderColor:
                                                        validator.cnpj === "false" ? "red" : "",
                                                }}
                                                onChange={handleChangeDocumento}
                                                placeholder="Ex: 00.000.000/0000-00"
                                                value={values.cnpj}
                                                disabled={props.desabilitar}
                                            />
                                            {validator.cnpj === "false" && (
                                                <p className="error-input-text">CNPJ/CPF inválido</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="coluna-emb">
                                        <div className="principal">
                                            <p className="input-label-emb">
                                                Regime Tributário:
                                            </p>
                                            <FormControl sx={{ width: 270 }}>
                                                <ReactSelect
                                                    value={valuesSelect.regimeTributario}
                                                    options={opcoesRegime}
                                                    formatOptionLabel={labelRegime}
                                                    styles={estiloCidadeEstado(false)}
                                                    menuPortalTarget={document.body}
                                                    placeholder="Selecione"
                                                    noOptionsMessage={() => "Não há mais opções"}
                                                    onChange={(selectedOption) => {
                                                        if (selectedOption) {
                                                            if (
                                                                selectedOption.value === "Simples nacional"
                                                            ) {
                                                                setValues((current) => ({
                                                                    ...current,
                                                                    regimeTributario: 1,
                                                                }));
                                                            } else if (
                                                                selectedOption.value === "Lucro presumido"
                                                            ) {
                                                                setValues((current) => ({
                                                                    ...current,
                                                                    regimeTributario: 2,
                                                                }));
                                                            } else if (
                                                                selectedOption.value === "Lucro real"
                                                            ) {
                                                                setValues((current) => ({
                                                                    ...current,
                                                                    regimeTributario: 3,
                                                                }));
                                                            }
                                                            setValuesSelect((current) => ({
                                                                ...current,
                                                                regimeTributario: selectedOption,
                                                            }));
                                                        }
                                                    }}
                                                />
                                            </FormControl>
                                        </div>
                                    </div>
                                </div>
                                <div className="container-form-column">
                                    <div className="coluna-emb">
                                        <div className="principal">
                                            <p className="input-label-emb">
                                                Rua:
                                            </p>
                                            <input
                                                type="text"
                                                id="rua"
                                                className="input-emb"
                                                style={{
                                                    width: "250px",
                                                    borderColor:
                                                        validator.rua === "false" ? "red" : "",
                                                }}
                                                onChange={(e) => {
                                                    setValues((current) => ({
                                                        ...current,
                                                        rua: e.target.value,
                                                    }));
                                                    setValidator((current) => ({
                                                        ...current,
                                                        rua: "true",
                                                    }));
                                                }}
                                                placeholder="Ex: Rua das Flores"
                                                value={values.rua}
                                                disabled={props.desabilitar}
                                            />
                                            {validator.rua === "false" && (
                                                <p className="error-input-text">Rua inválida</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="coluna-emb">
                                        <div className="principal">
                                            <p className="input-label-emb">
                                                Número:
                                            </p>
                                            <input
                                                type="text"
                                                id="numero"
                                                className="input-emb"
                                                style={{
                                                    width: "250px",
                                                    borderColor:
                                                        validator.numero === "false" ? "red" : "",
                                                }}
                                                onChange={(e) => {
                                                    setValues((current) => ({
                                                        ...current,
                                                        numero: e.target.value === "" ? 0 : e.target.value,
                                                    }));
                                                    setValidator((current) => ({
                                                        ...current,
                                                        numero: e.target.value === "" ? "false" : "true",
                                                    }));
                                                }}
                                                placeholder="57"
                                                value={values.numero}
                                                disabled={props.desabilitar}
                                            />
                                            {validator.numero === "false" && (
                                                <p className="error-input-text">Número inválido</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="coluna-emb">
                                        <div className="principal">
                                            <p className="input-label-emb">
                                                Bairro:
                                            </p>
                                            <input
                                                type="text"
                                                id="bairro"
                                                className="input-emb"
                                                style={{
                                                    width: "250px",
                                                    borderColor:
                                                        validator.bairro === "false" ? "red" : "",
                                                }}
                                                onChange={(e) => {
                                                    setValues((current) => ({
                                                        ...current,
                                                        bairro: e.target.value,
                                                    }));
                                                    setValidator((current) => ({
                                                        ...current,
                                                        bairro: "true",
                                                    }));
                                                }}
                                                placeholder="Ex: Bairro São José"
                                                value={values.bairro}
                                                disabled={props.desabilitar}
                                            />
                                            {validator.bairro === "false" && (
                                                <p className="error-input-text">Bairro inválido</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="coluna-emb">
                                        <div className="principal">
                                            <p className="input-label-emb">
                                                CEP:
                                            </p>
                                            <input
                                                type="text"
                                                id="cep"
                                                className="input-emb"
                                                style={{
                                                    width: "250px",
                                                    borderColor:
                                                        validator.cep === "false" ? "red" : "",
                                                }}
                                                onChange={(e) => {
                                                    setValues((current) => ({
                                                        ...current,
                                                        cep: e.target.value.replace(/\D/g, ""),
                                                    }));
                                                    setValidator((current) => ({
                                                        ...current,
                                                        cep: "true",
                                                    }));
                                                }}
                                                onBlur={(e) => {
                                                    const cep = e.target.value;
                                                    if (!/^\d{8}$/.test(cep)) {
                                                        setValidator((current) => ({
                                                            ...current,
                                                            cep: "false",
                                                        }));
                                                        setTextoErro("CEP inválido");
                                                        setOpenToastErro(true);
                                                    }
                                                }}
                                                placeholder="Ex: 86060-000"
                                                value={values.cep}
                                                disabled={props.desabilitar}
                                            />
                                            {validator.cep === "false" && (
                                                <p className="error-input-text">CEP inválido</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="coluna-emb">
                                        <div className="principal">
                                            <p className="input-label-emb">
                                                Cidade/UF:
                                            </p>
                                            <FormControl sx={{
                                                width: 270,
                                                borderColor: validator.cidadeEstadoId === "false" ? "red" : "",
                                            }}>
                                                <ReactSelect
                                                    value={valuesSelect.cidadeEstadoId}
                                                    isDisabled={props.desabilitar}
                                                    options={opcoesCidadeEstado}
                                                    formatOptionLabel={labelCidadeEstado}
                                                    styles={estiloCidadeEstado(validator.cidadeEstadoId === "false")}
                                                    menuPortalTarget={document.body}
                                                    placeholder="Selecione"
                                                    noOptionsMessage={() => "Não há mais opções"}
                                                    onChange={(selectedOption) => {
                                                        if (selectedOption) {
                                                            setValues((current) => ({
                                                                ...current,
                                                                cidadeEstadoId: selectedOption.idCidadeEstado,
                                                            }));
                                                            setValuesSelect((current) => ({
                                                                ...current,
                                                                cidadeEstadoId: selectedOption,
                                                            }));
                                                            setValidator((current) => ({
                                                                ...current,
                                                                cidadeEstadoId: "true",
                                                            }));
                                                        }
                                                    }}
                                                />
                                                {validator.cidadeEstadoId === "false" && (
                                                    <p className="error-input-text">Cidade/UF inválido</p>
                                                )}
                                            </FormControl>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="footer-container">
                            {editando ? (
                                <CustomButtonV2
                                    classCss="custom-button-cadastrar"
                                    classText="button-texto-cadastrar"
                                    icone="iconeSave"
                                    titulo="Salvar"
                                    cor="#0946B8"
                                    valor={values}
                                    onClick={editar}
                                />
                            ) : (
                                <>
                                    {!props.desabilitar && (
                                        <CustomButtonV2
                                            classCss="custom-button-cadastrar"
                                            classText="button-texto-cadastrar"
                                            icone="iconeSave"
                                            titulo="Salvar"
                                            cor="#0946B8"
                                            valor={values}
                                            onClick={cadastrar}
                                        />
                                    )}
                                </>
                            )}
                            {!props.botaoVoltar && (
                                <CustomButtonV2
                                    classCss="custom-button-cancelar"
                                    classText="button-texto-cancelar"
                                    titulo="Cancelar"
                                    cor="#0946B8"
                                    valor={values}
                                    onClick={() => {
                                        setValues({});
                                        setValuesSelect({});
                                        setTelaCadastro(false);
                                        setEditando(false);
                                        if (!!props.onCloseModal) {
                                            props.onCloseModal();
                                        }
                                    }}
                                />
                            )}
                        </div>
                    </MotionContainer>
                )}
            </AnimatePresence>
            <ModalConfirmacao
                titulo="Deletar"
                texto="Deseja Deletar?"
                tituloConfirmar="Confirmar"
                tituloCancelar="Cancelar"
                open={open}
                onClose={handleClose}
                onClick={deletarEmpresa}
            />
            <ModalUsuario
                titulo="Usuário"
                tituloConfirmar="OK"
                open={openUsuario}
                onClose={handleCloseUsuario}
            />
            <ToastSucesso
                texto={textoSucesso}
                open={openToastSucesso}
                onClose={handleCloseToastSucesso}
            />
            <ToastErro
                texto={textoErro}
                open={openToastErro}
                onClose={handleCloseToastErro}
            />
        </Layout>
    )
        ;
}

export default EmpresaSubsidiaria;
